(function (angular) {
    angular.module("app").controller("InputsFrontendElementsCtrl", ["$scope", function ($scope) {}]);
})(angular);